import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const dialedDigitExtractionServerTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Dialed DigitExtraction Server',
  key: 'dialedDigitExtractionServer',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['msid', 'ipaddr', 'port'],
          ['ownnetid', 'reqstate', '$empty'],
          ['$empty', 'asstate', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      msid: {
        label: 'Media Server ID',
        type: 'text',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
            {
              type: 'length',
              length: 16,
              errorMessage: 'Exceeds maximum length, 16.  Please re-enter.',
            },
          ],
        },
      },
      ipaddr: {
        label: 'AF IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 42,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      port: {
        label: 'AF Port',
        type: 'text',
        initial: '0',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
      ownnetid: {
        label: 'Network ID',
        type: 'advancedSelect',
        initial: '',
        placeholder: 'Select a Network ID',
        allowCreate: true,
        options: [],
        optionsFormat: 'networkIdAndIpAddress',
        validation: {
          validators: [
            {
              type: 'customFunction',
              customValidationFunction: 'networkIdNotFoundValidator',
              errorMessage: 'Please select another network ID.',
            },
          ],
        },
      },
      reqstate: {
        label: 'Configured State',
        type: 'select',
        initial: 'ACTIVE',
        options: [
          {
            label: 'Active',
            value: 'ACTIVE',
          },
          {
            label: 'Inactive',
            value: 'INACTIVE',
          },
        ],
        optionsTranslatable: true,
      },
      asstate: {
        label: 'Current State',
        type: 'custom',
        initial: '',
        hide: 'true',
        customComponent: 'accessFunctionCurrentState',
        className: 'field-current-state',
      },
    },
  },
};
